import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { UiDateTimePickerModule } from '@components/ui-datetime-picker/ui-datetime-picker.module';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { SharedModule } from '@modules';
import { UiQueueSchemaComponent } from '@pages/queues/upsert/ui-queue-schema/ui-queue-schema.component';
import { UiTimeOffsetPickerComponent } from '@pages/queues/upsert/ui-time-offset-picker/ui-time-offset-picker.component';
import { QueueDefinitionService } from '@services';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiDragAndDropModule } from '@uipath/angular/directives/ui-drag-and-drop-file';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiProgressButtonModule } from '@uipath/angular/directives/ui-progress-button';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { QueueUpsertPageComponent } from './queue.upsert.page';

@NgModule({
  imports: [
    CommonModule,
    UiNgLetModule,
    MatCardModule,
    SharedModule,
    UiAutofocusModule,
    UiToggleSwitchModule,
    UiContentLoaderModule,
    UiSpinnerButtonModule,
    UiDragAndDropModule,
    UiProgressButtonModule,
    UiSuggestModule,
    UiDateTimePickerModule,
  ],
  declarations: [
    QueueUpsertPageComponent,
    UiQueueSchemaComponent,
    UiTimeOffsetPickerComponent,
  ],
  providers: [
    QueueDefinitionService,
  ],
  exports: [QueueUpsertPageComponent],
})
export class QueueUpsertModule { }
